import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClientJsonpModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule, LOCALE_ID } from '@angular/core';
import { } from '@angular/common/locales/pl';
import { JwtModule } from '@auth0/angular-jwt';

import { AppRoutingModule } from './app-routing.module';
// --- Settings
import { Config } from './config';
// --- Utils
import { Utils } from './utils';

// --- Guards
import { AuthGuard } from './services';

// --- Services
import {
    AuthenticationService, UserService, ValidatorService, TicketService,
    AdministrationService, HotparkingService, ReservationRetailService, ReservationTenantService
} from './services';

// --- Components
import { AppComponent } from './app.component';
import { HeaderComponent, FooterComponent } from './components';
import { AuthComponent, PasswordComponent } from './components/auth';
import { DashboardComponent } from './components/dashboard';
import { ValidationComponent } from './components/validation';
import { UsersComponent, UsersListComponent, UsersViewComponent, UsersConfigComponent, UsersRolesComponent } from './components/users';
import {
    ValidatorsComponent, ValidatorsListComponent, ValidatorsViewComponent, ValidatorsOptionsComponent, ValidatorsConfigComponent,
    ValidatorsConfigViewComponent, ValidatorsConfigPermissionComponent, ValidatorConfigListComponent
} from './components/validators';
import { ProfileComponent } from './components/profile';

import { AccordionModule } from 'primeng/accordion';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { CameraComponent, CamerasComponent } from './components/cameras';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FieldsetModule } from 'primeng/fieldset';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { HotParkingComponent, PubHotParkingComponent } from './components/hot-parking';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputTextModule } from 'primeng/inputtext';
import { LprComponent } from './components/lpr';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from 'primeng/multiselect';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { ReservationRetailCancelComponent, ReservationRetailComponent } from './components/reservation-retail';
import { ReservationTenantsComponent, ReservationTenantsDetailsComponent, ReservationTenantsListComponent } from './components/reservation-tenants';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { MessageService } from 'primeng/api';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { ValidationReportComponent } from './components/validation-report/validation-report.component';
import { registerLocaleData, Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import localePL from "@angular/common/locales/pl";
registerLocaleData(localePL, "pl-PL");

export function tokenGetter() {
    return localStorage.getItem("access_token");
}

@NgModule({
    declarations: [
        AppComponent,
        AuthComponent,
        CameraComponent,
        CamerasComponent,
        DashboardComponent,
        FooterComponent,
        HeaderComponent,
        HotParkingComponent,
        LprComponent,
        PasswordComponent,
        ProfileComponent,
        PubHotParkingComponent,
        ReservationRetailCancelComponent,
        ReservationRetailComponent,
        ReservationTenantsComponent,
        ReservationTenantsDetailsComponent,
        ReservationTenantsListComponent,
        UsersComponent,
        UsersConfigComponent,
        UsersListComponent,
        UsersRolesComponent,
        UsersViewComponent,
        ValidationComponent,
        ValidatorConfigListComponent,
        ValidatorsComponent,
        ValidatorsConfigComponent,
        ValidatorsConfigPermissionComponent,
        ValidatorsConfigViewComponent,
        ValidatorsListComponent,
        ValidatorsOptionsComponent,
        ValidatorsViewComponent,
        ValidationReportComponent
    ],
    imports: [
        AccordionModule,
        AppRoutingModule,
        BlockUIModule,
        BrowserModule,
        BrowserAnimationsModule,
        ButtonModule,
        CalendarModule,
        CheckboxModule,
        ChipsModule,
        DialogModule,
        DropdownModule,
        FieldsetModule,
        FontAwesomeModule,
        FormsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        InputNumberModule,
        InputSwitchModule,
        InputTextareaModule,
        InputTextModule,
        JwtModule.forRoot({
            config: {
                tokenGetter: tokenGetter,
                whitelistedDomains: ['10.100.40.99', 'eparking.ws-re.com', 'localhost', 'localhost:4200'],
                blacklistedRoutes: ['/api/rs/auth/login', '/api/rs/pub']
            }
        }),
        MessageModule,
        MessagesModule,
        MultiSelectModule,
        NgxDatatableModule,
        OverlayPanelModule,
        PaginatorModule,
        PanelModule,
        ReactiveFormsModule,
        TableModule,
        TabViewModule,
        ToastModule,
        TriStateCheckboxModule
    ],
    providers: [
        AdministrationService,
        AuthenticationService,
        AuthGuard,
        Config,
        HotparkingService,
        MessageService,
        ReservationRetailService,
        ReservationTenantService,
        TicketService,
        UserService,
        Utils,
        ValidatorService,
      Location,
      { provide: LocationStrategy, useClass: PathLocationStrategy },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(iconLibrary: FaIconLibrary) {
        iconLibrary.addIconPacks(fas);
    }
}
